function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable complexity */

/* eslint-disable max-statements */
import React from 'react';
import { webImageUri } from 'src/utils/uri';
import bgHeroSole from 'assets/img/bg_box_footer.png';
import bgEllipseHero from 'assets/img/bg_ellipse_hero.png';
import icInfoYellow from 'assets/svg/ic_info_yellow.svg';
import icLocked from 'assets/svg/ic_lock_white_fill.svg';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import icPlus from 'assets/svg/ic_plus.svg';
import ic3D from 'assets/svg/ic_3d.svg';
import icMouse from 'assets/svg/ic_mouse.svg';
import { useCheckout } from 'src/Pages/ItemDetailV2/CheckoutProvider';
import { useSellHero } from 'src/Pages/ItemDetailV2/HeroSaleProvider';
import { useRentOut } from 'src/Pages/ItemDetailV2/RentOutProvider';
import HeroPlaceholder from 'src/Components/HeroPlaceholder';
import Spinner from 'src/Components/Spinner';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import HeroLevelIcon from 'src/Components/HeroLevelV2';
import HeroTrophyIcon from 'src/Components/HeroTrophy';
import StatsSection from './StatsSection';
import RenterBenefitCard from './RenterBenefitCard';
import P2EPanel from './StatsSection/P2EPanel';
import StatsPanel from './StatsSection/StatsPanel';
import ComingSoonPanel from './StatsSection/ComingSoonPanel';
import styles from './styles.module.scss';
import { currencyIconMap, HeroClassName, HeroStatus, NtfHeroClassType } from 'src/utils/types';
import SkinRarityCard from './SkinRarityCard';
import { ellipsisMiddle } from 'src/utils/text';
import { useTypedSelector } from 'src/redux/utils';
import classNames from 'classnames';
import { formatRentedOutPeriod, getButtonGroupStatus, getGuestButtonStatus, getInventoryButtonStatus, getRentalButtonStatus } from './utils';
import { ButtonGroupStatus, GuestButtonStatus, InventoryButtonStatus, RentalButtonStatus } from './types';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import { useUserWalletContext } from '@profile/src/Profile_V2/UserWalletProvider';
import HeroRarityCard from './HeroRarityCard';
import HeroClassCard from './HeroClassCard';
import Button from './Button';
import { heroRarityStyleMap } from './config';
import { ReactTooltip, TooltipPosition } from 'src/Components/TooltipProviderV2';
import { StatsTab } from './StatsSection/utils';
import BreakpointContent from 'src/Components/BreakpointContent';
import BackButton from 'src/Components/BackButton';
import { useUnlockHero } from 'src/Pages/ItemDetailV2/UnlockHeroProvider';
import MintContent from './ContentTooltips/MintContent';
import { useMintHero } from 'src/Pages/ItemDetailV2/MintHeroProvider';
import MintButton from './MintButton';
import ButtonV2 from 'src/Components/Button_V2';
import { hasCached } from 'src/utils/cacheStorage';
import { useTestId } from '@wolffun/testable-id';

const ItemDetail = ({
  heroDetail,
  className,
  onClickGoBack,
  refreshData
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const [isShowDecoHero, setShowDecoHero] = React.useState(true);
  const {
    rarityType: heroRarityClassName,
    deco
  } = heroRarityStyleMap[heroDetail.hero.rarity];
  const user = useTypedSelector(state => state.userProfile.user);
  const {
    data: mintConfig
  } = useTypedSelector(state => state.mintConfig);
  const {
    loading: loadingUnlock
  } = useTypedSelector(state => state.unlockHeroRental);
  const {
    loading: loadingMint
  } = useTypedSelector(state => state.mintHero);
  const expiredTimeMint = useTypedSelector(state => {
    var _state$ingameBalance$;

    return ((_state$ingameBalance$ = state.ingameBalance.data.userCap) === null || _state$ingameBalance$ === void 0 ? void 0 : _state$ingameBalance$.expiredMintHero) || 0;
  });
  const {
    checkWalletError
  } = useUserWalletContext();
  const {
    unlockHero
  } = useUnlockHero();
  const {
    mintHero
  } = useMintHero();
  const heroDescriptionConfigs = useTypedSelector(state => state.heroDescriptionConfigs.description);
  const heroReward = useTypedSelector(state => state.heroDescriptionConfigs.reward);
  const isShowWarning = heroDetail.hero.status === HeroStatus.DEFAULT || heroDetail.hero.status === HeroStatus.MINTING || heroDetail.hero.status === HeroStatus.NOT_MINT || heroDetail.hero.status === HeroStatus.PREPARE_SELLING || heroDetail.hero.status === HeroStatus.PREPARE_UNLOCKING || heroDetail.hero.status === HeroStatus.USER_MINTING || heroDetail.hero.status === HeroStatus.PREPARE_LENDING;
  const mintBtnDisabled = Date.now() < expiredTimeMint || (mintConfig === null || mintConfig === void 0 ? void 0 : mintConfig.minHeroLevel) === undefined || heroDetail.hero.level < mintConfig.minHeroLevel;
  const isHiddenMintMsg = (mintConfig === null || mintConfig === void 0 ? void 0 : mintConfig.minHeroLevel) === 1;
  const {
    startCheckout
  } = useCheckout();
  const {
    sellHero,
    stopSellingHero
  } = useSellHero();
  const {
    stopRentOut
  } = useRentOut();
  const price = heroDetail.hero.systemPrice;
  const {
    rentInfo
  } = heroDetail.hero;
  const rentPrice = rentInfo.cost;
  const groupButtonRef = React.useRef(null);
  const isOwner = (user === null || user === void 0 ? void 0 : user.address.toLocaleLowerCase()) === heroDetail.hero.userAddress.toLocaleLowerCase();
  const [isShowButtonFixed, setShowButtonFixed] = React.useState(true);

  const handleGroupButton = () => {
    var _groupButtonRef$curre;

    const rect = (_groupButtonRef$curre = groupButtonRef.current) === null || _groupButtonRef$curre === void 0 ? void 0 : _groupButtonRef$curre.getBoundingClientRect();

    if (window.innerHeight >= ((rect === null || rect === void 0 ? void 0 : rect.height) || 0) + ((rect === null || rect === void 0 ? void 0 : rect.top) || 0)) {
      setShowButtonFixed(false);
    } else {
      setShowButtonFixed(true);
    }
  };

  React.useEffect(() => {
    document.addEventListener('scroll', handleGroupButton);
    return () => {
      document.removeEventListener('scroll', handleGroupButton);
    };
  }, []);
  const buttonGroupStatus = getButtonGroupStatus({
    heroDetail,
    currentUser: user
  });
  const guestButtonStatus = getGuestButtonStatus(heroDetail);
  const rentalButtonStatus = getRentalButtonStatus(heroDetail);
  const isInTransactionProcess = HeroStatus.IN_TRANSACTION_PROCESS === heroDetail.hero.status;
  const isStaking = heroDetail.hero.status === HeroStatus.IN_STAKING;
  const rentedOutButton = /*#__PURE__*/React.createElement(Button, _extends({
    className: classNames(styles.buyNow),
    disabled: true,
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Rented\xA0", /*#__PURE__*/React.createElement("span", {
      className: styles.expiredTimeRent
    }, "(", formatRentedOutPeriod(rentInfo.expiredTime), ")"))
  }, generateTestIdProps('rented-button')));
  const inventoryStatus = React.useMemo(() => getInventoryButtonStatus(heroDetail), [heroDetail]);

  const renderInventoryButton = () => {
    switch (inventoryStatus) {
      case InventoryButtonStatus.IS_AVAILABLE:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.btnGroup
        }, /*#__PURE__*/React.createElement(Button, _extends({
          className: classNames(styles.buyNow, styles.sell),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            sellHero(heroDetail);
          },
          title: "Sell"
        }, generateTestIdProps('sell-button'))));

      case InventoryButtonStatus.IS_RENTING:
        return /*#__PURE__*/React.createElement(Button, _extends({
          className: classNames(styles.buyNow, styles.cancel),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            stopRentOut(heroDetail);
          },
          title: "Cancel renting"
        }, generateTestIdProps('cancel-renting-button')));

      case InventoryButtonStatus.IS_SELLING:
        return /*#__PURE__*/React.createElement(Button, _extends({
          className: classNames(styles.buyNow, styles.cancel),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            stopSellingHero(heroDetail);
          },
          title: "Stop selling"
        }, generateTestIdProps('stop-selling-button')));

      case InventoryButtonStatus.IS_RENTED:
        return rentedOutButton;

      case InventoryButtonStatus.IS_LOCKED:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.wrapSingleButton
        }, renderStatus(), /*#__PURE__*/React.createElement(Button, _extends({
          loading: loadingUnlock,
          className: classNames(styles.buyNow),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            unlockHero(heroDetail);
          }
        }, generateTestIdProps('activate-button'), {
          title: loadingUnlock ? 'Processing' : 'Activate'
        })));

      case InventoryButtonStatus.IS_NOT_MINT:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.wrapSingleButton
        }, renderStatus(), /*#__PURE__*/React.createElement(MintButton, _extends({
          disabled: mintBtnDisabled,
          loading: loadingMint,
          className: classNames(classNames(styles.buyNow, styles.mintBtn)),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            mintHero(heroDetail);
          }
        }, generateTestIdProps('mint-button'), {
          title: loadingMint ? 'Processing' : 'Mint',
          expiredTime: expiredTimeMint,
          onFinished: refreshData
        })));

      default:
        return null;
    }
  };

  const renderGuestButton = () => {
    let Element;

    switch (guestButtonStatus) {
      case GuestButtonStatus.IS_RENTED:
        Element = rentedOutButton;
        break;

      case GuestButtonStatus.IS_NOT_AVAILABLE:
        {
          Element = /*#__PURE__*/React.createElement("div", {
            className: styles.btnGroup
          }, /*#__PURE__*/React.createElement(Button, _extends({
            className: classNames(styles.buyNow, styles.notForSale),
            disabled: true,
            title: "Not for sale"
          }, generateTestIdProps('not-for-sale-button'))));
          break;
        }

      default:
        Element = null;
        break;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapSingleButton
    }, Element);
  };

  const renderStatusText = () => {
    switch (heroDetail.hero.status) {
      case HeroStatus.MINTING:
        return 'Minting your item...';

      case HeroStatus.NOT_MINT:
        return "This item is not mint and can't be sold on the marketplace";

      case HeroStatus.DEFAULT:
        return "This item is free to use in-game and can't be sold on the marketplace.";

      case HeroStatus.PREPARE_SELLING:
      case HeroStatus.PREPARE_LENDING:
      case HeroStatus.PREPARE_UNLOCKING:
      case HeroStatus.USER_MINTING:
        return 'The blockchain system is processing, please wait...';

      default:
        return '';
    }
  };

  const renderToastSkinRarity = /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.skinRarityContent, styles.tooltipMobile)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, "Skin rarity"), /*#__PURE__*/React.createElement("p", {
    className: styles.body
  }, "Skin rarity is determined by the frequency of the skin in the selling pool. The rarer the cosmetic is, the better it looks like, more visual effects and bonuses in battle rewards."), /*#__PURE__*/React.createElement("p", {
    className: styles.footer
  }, "There are 3 different levels of skin rarity:"), /*#__PURE__*/React.createElement("p", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.default
  }, "Normal Skin"), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.triangle, styles.arrow)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rare
  }, "Rare Skin"), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.triangle, styles.arrow)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.mythical
  }, "Mythical Skin")));
  const renderHeroRarityContent = /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.heroRarityContent, styles.tooltipMobile)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, "Hero rarity"), /*#__PURE__*/React.createElement("p", {
    className: styles.body
  }, "Heroes with a higher rarity have more unique playstyles, abilities and will have a chance to get bonuses in battle rewards."), /*#__PURE__*/React.createElement("p", {
    className: styles.footer
  }, "There are 3 different levels of hero rarity:"), /*#__PURE__*/React.createElement("p", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.commonHero
  }, "Common Hero"), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.triangle, styles.arrow, styles.epicHero)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.epicHero
  }, "Epic Hero"), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.triangle, styles.arrow, styles.legendaryHero)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.legendaryHero
  }, "Legendary Hero")));
  const renderHeroTrophyDetail = /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.trophyContent, styles.trophyClass, styles.tooltipMobile)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, "Trophy class"), /*#__PURE__*/React.createElement("p", {
    className: styles.body
  }, "Trophy Class represents the mastery of using a hero. Trophy Class increase the power of the custom skills chosen by heroes in the game."), /*#__PURE__*/React.createElement("p", {
    className: styles.body
  }, "The Trophy Class will be graded from:"), /*#__PURE__*/React.createElement("p", {
    className: styles.footer
  }, "H > G > F > E > D > C > B > A > S > SS."));

  const renderClassContent = role => {
    switch (role) {
      case NtfHeroClassType.TANK:
        {
          return 'Tank heroes are responsible for becoming frontlines facing up to the enemies and prevent their teammates from receiving damages';
        }

      case NtfHeroClassType.MARKSMAN:
        {
          return 'Marksmans are the main damage dealers and are responsible for maintaining the DPS amount during the fight.';
        }

      case NtfHeroClassType.ASSASSIN:
        {
          return 'Assassins are deadly and silent killers who can engage the fight, eliminate the target in a single combo, and retreat without being noticed.';
        }

      default:
        return undefined;
    }
  };

  const renderHeroClassDetail = role => /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.classContent, styles.tooltipMobile)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, "Class: ", HeroClassName[role]), /*#__PURE__*/React.createElement("p", {
    className: styles.body
  }, renderClassContent(role)));

  const renderButton = () => {
    switch (buttonGroupStatus) {
      case ButtonGroupStatus.INVENTORY:
        return renderInventoryButton();

      case ButtonGroupStatus.RENTAL:
        return renderRentalButton();

      case ButtonGroupStatus.SALE:
        return renderSaleButton();

      case ButtonGroupStatus.GUEST:
        return renderGuestButton();

      default:
        return null;
    }
  };

  const renderStatus = () => {
    if (!isOwner) {
      return null;
    }

    const {
      status
    } = heroDetail.hero;

    switch (status) {
      case HeroStatus.USER_NOT_MINT:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.wrapStatus
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mint
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames(styles.wrapLabel, isHiddenMintMsg && styles.hidenMintMsg)
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.imgLock,
          src: icLocked
        }), /*#__PURE__*/React.createElement("span", {
          className: styles.span
        }, "Not Mint"), /*#__PURE__*/React.createElement(ReactTooltip, {
          className: styles.tooltip,
          position: TooltipPosition.TOP,
          content: /*#__PURE__*/React.createElement(MintContent, null)
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.imgInfo,
          src: icInfo
        }))), !isHiddenMintMsg && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: styles.separation
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapConditional
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.txtBody
        }, "Hero level required to mint:"), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapValue
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.txtLabel
        }, "Level\xA0"), !!mintConfig && /*#__PURE__*/React.createElement("span", {
          className: styles.txtValue
        }, mintConfig.minHeroLevel), /*#__PURE__*/React.createElement("img", {
          src: icPlus,
          className: styles.icPlus
        }))))));

      default:
        return null;
    }
  };

  const renderRentalButton = () => {
    switch (rentalButtonStatus) {
      case RentalButtonStatus.IS_RENTED:
        return rentedOutButton;

      default:
        return null;
    }
  };

  const renderSaleButton = () => {
    return /*#__PURE__*/React.createElement(Button, _extends({
      className: styles.buyNow,
      onClick: () => {
        if (checkWalletError()) {
          return;
        }

        startCheckout(heroDetail);
      },
      title: "Buy"
    }, generateTestIdProps('buy-button')));
  };

  const renderPrice = () => {
    if (isStaking) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.warningStatus
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.icon,
        src: icInfoYellow
      }), /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.span, styles.staking)
      }, "This items is not minted and can not be sold on the marketplace"));
    }

    if (heroDetail.hero.status === HeroStatus.FUSING) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.warningStatus
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.span, styles.processing)
      }, "Fusion..."));
    }

    if (isInTransactionProcess) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.warningStatus
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.span, styles.processing)
      }, "Processing..."));
    }

    if (isOwner && isShowWarning) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.warningStatus
      }, /*#__PURE__*/React.createElement("img", {
        src: icInfoYellow,
        className: styles.icon
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.span
      }, renderStatusText()));
    }

    if (inventoryStatus === InventoryButtonStatus.IS_AVAILABLE || inventoryStatus === InventoryButtonStatus.IS_LOCKED || inventoryStatus === InventoryButtonStatus.IS_NOT_MINT || inventoryStatus === InventoryButtonStatus.IS_PROCESSING) {
      return renderButton();
    }

    if (heroDetail.hero.status === HeroStatus.RENTED || heroDetail.hero.status === HeroStatus.FOR_RENT) {
      return rentPrice ? /*#__PURE__*/React.createElement("div", {
        className: styles.wrapRentPrice
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rentPrice
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rentPriceRow
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.purchase
      }, "Renting price:"), /*#__PURE__*/React.createElement("div", {
        className: styles.priceRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrapIcon
      }, rentPrice && currencyIconMap[rentPrice.token] && /*#__PURE__*/React.createElement("img", {
        draggable: false,
        src: currencyIconMap[rentPrice.token],
        className: styles.icon
      })), /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.spanPrice, styles.spanRentPrice)
      }, formatCurrency(rentPrice, {
        withCurrency: true,
        trimWholeFraction: true
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.wrapEqual
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.equal, styles.spanRentPrice)
      }, "\u2248")), /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.subSpanPrice, styles.spanRentPrice)
      }, formatCurrencyInFiat(rentPrice, {
        withCurrency: true,
        trimWholeFraction: true
      })))), /*#__PURE__*/React.createElement("div", {
        className: styles.rentPriceRow
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.purchase
      }, "Battles for rent:"), /*#__PURE__*/React.createElement("span", {
        className: styles.battle
      }, rentInfo.rentBattles))), renderButton()) : null;
    }

    if (!price) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapPrice
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.priceRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapIcon
    }, price && currencyIconMap[price.token] && /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: currencyIconMap[price.token],
      className: styles.icon
    })), /*#__PURE__*/React.createElement("span", _extends({
      className: styles.spanPrice
    }, generateTestIdProps('price-THC')), formatCurrency(price, {
      withCurrency: true,
      trimWholeFraction: true
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapEqual
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.equal
    }, "\u2248")), /*#__PURE__*/React.createElement("span", _extends({
      className: styles.subSpanPrice
    }, generateTestIdProps('price-USD')), formatCurrencyInFiat(price, {
      withCurrency: true,
      trimWholeFraction: true
    }))), renderButton());
  };

  const renderHeroInfo = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.line, styles[heroRarityClassName])
    }), /*#__PURE__*/React.createElement("span", {
      className: classNames(styles.skinName, styles[heroRarityClassName])
    }, heroDetail.skin.name), /*#__PURE__*/React.createElement("span", _extends({
      className: styles.name
    }, generateTestIdProps('hero-name')), heroDetail.heroType.name), /*#__PURE__*/React.createElement("div", {
      className: styles.heroLabel
    }, /*#__PURE__*/React.createElement(HeroLevelIcon, {
      value: heroDetail.hero.level
    }), /*#__PURE__*/React.createElement(ReactTooltip, {
      className: styles.rarityItem,
      content: renderHeroTrophyDetail,
      position: TooltipPosition.LEFT
    }, /*#__PURE__*/React.createElement(HeroTrophyIcon, {
      className: styles.trophy,
      value: heroDetail.hero.trophy
    })))), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapRarity
    }, /*#__PURE__*/React.createElement(ReactTooltip, {
      className: styles.rarityItem,
      content: renderToastSkinRarity,
      position: TooltipPosition.BOTTOM
    }, /*#__PURE__*/React.createElement(SkinRarityCard, {
      value: heroDetail.skin.skinRarity
    })), /*#__PURE__*/React.createElement(ReactTooltip, {
      className: styles.rarityItem,
      content: renderHeroRarityContent,
      position: TooltipPosition.BOTTOM
    }, /*#__PURE__*/React.createElement(HeroRarityCard, {
      className: styles.heroRarity,
      value: heroDetail.hero.rarity
    })), /*#__PURE__*/React.createElement(ReactTooltip, {
      className: styles.rarityItem,
      content: renderHeroClassDetail((heroDescriptionConfigs === null || heroDescriptionConfigs === void 0 ? void 0 : heroDescriptionConfigs[heroDetail.heroType.id].role) || 0),
      position: TooltipPosition.BOTTOM
    }, /*#__PURE__*/React.createElement(HeroClassCard, {
      value: heroDescriptionConfigs ? heroDescriptionConfigs[heroDetail.heroType.id].role : 0
    }))));
  };

  let LoadState;

  (function (LoadState) {
    LoadState["BEFORE"] = "BEFORE";
    LoadState["LOADING"] = "LOADING";
    LoadState["AFTER"] = "AFTER";
  })(LoadState || (LoadState = {}));

  const [itemViewMode, setItemViewMode] = React.useState('2D');
  const [loading3D, setLoading3D] = React.useState(LoadState.BEFORE);
  const [displayHint, setDisplayHint] = React.useState(true);
  React.useEffect(() => {
    const checkCached = async () => {
      if (!heroDetail.skin.model3D) return;
      const isCached = await hasCached(webImageUri(heroDetail.skin.model3D));
      if (isCached) setItemViewMode('3D');
    };

    checkCached();
  }, [heroDetail.skin.model3D]);

  const renderHeroImg = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      draggable: false,
      className: styles.ellipse,
      src: bgEllipseHero
    }), itemViewMode === '2D' && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      className: styles.heroImg,
      src: webImageUri(heroDetail.skin.imageFull),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
        secondary: true,
        className: styles.loading
      })
    }), itemViewMode === '3D' && heroDetail.skin.model3D && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroPlaceholder, {
      className: styles.heroAnimation,
      src: webImageUri(heroDetail.skin.model3D),
      onCompleted: () => setLoading3D(LoadState.AFTER),
      scaleRatio: heroDetail.skin.scaleRatio,
      disableHint: () => setDisplayHint(false)
    }), /*#__PURE__*/React.createElement(ButtonV2, {
      title: "Drag & Click to view",
      icon: icMouse,
      className: classNames(styles.dragView, loading3D === LoadState.AFTER && displayHint ? null : styles.hidden)
    })), heroDetail.skin.model3D && loading3D !== LoadState.AFTER && /*#__PURE__*/React.createElement(ButtonV2, {
      title: loading3D === LoadState.LOADING ? 'Loading 3D Model ...' : 'Click to view 3D Model',
      icon: ic3D,
      disabled: loading3D === LoadState.LOADING,
      type: "outlined",
      className: styles.switchView,
      onClick: () => {
        setLoading3D(LoadState.LOADING);
        setItemViewMode('3D');
      }
    }), /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: bgHeroSole,
      className: styles.sole
    }));
  };

  const renderOwner = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapOwner
    }, !!heroDetail.hero.tokenId && /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "ID:"), /*#__PURE__*/React.createElement("span", _extends({
      className: styles.valueID
    }, generateTestIdProps('hero-id')), "#", heroDetail.hero.tokenId)), /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "Owner:"), !isOwner ? /*#__PURE__*/React.createElement("span", _extends({
      className: styles.valueOwner
    }, generateTestIdProps('owner-id')), ellipsisMiddle(heroDetail.hero.userAddress)) : /*#__PURE__*/React.createElement("span", {
      className: styles.valueOwner
    }, "Owner by me")));
  };

  const renderRentalReward = () => {
    return buttonGroupStatus === ButtonGroupStatus.RENTAL ? /*#__PURE__*/React.createElement(RenterBenefitCard, {
      className: styles.renterCard
    }) : null;
  };

  const renderedPanel = tab => {
    switch (tab) {
      case StatsTab.P2E:
        {
          return /*#__PURE__*/React.createElement(P2EPanel, {
            item: heroDetail,
            reward: heroReward
          });
        }

      case StatsTab.Stats:
        {
          return /*#__PURE__*/React.createElement(StatsPanel, {
            item: heroDetail,
            description: heroDescriptionConfigs === null || heroDescriptionConfigs === void 0 ? void 0 : heroDescriptionConfigs[heroDetail.heroType.id]
          });
        }

      case StatsTab.Hero:
        {
          return /*#__PURE__*/React.createElement("div", {
            className: styles.container
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.top
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.left
          }, renderHeroImg()), /*#__PURE__*/React.createElement("div", {
            className: styles.right
          }, renderHeroInfo(), renderRentalReward(), renderOwner())));
        }

      default:
        {
          return /*#__PURE__*/React.createElement(ComingSoonPanel, null);
        }
    }
  };

  const renderPhonePrice = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapPhonePrice
    }, renderPrice());
  };

  const renderMobileAndTablet = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StatsSection, {
    key: "renderMobileAndTablet",
    tabs: [StatsTab.Hero, StatsTab.P2E, StatsTab.Stats, StatsTab.Fury, StatsTab.Passive],
    className: styles.statsSection,
    renderedPanel: renderedPanel,
    onTabChanged: tab => {
      handleGroupButton();

      if (tab === StatsTab.Hero) {
        setShowDecoHero(true);
      } else {
        setShowDecoHero(false);
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: groupButtonRef,
    className: classNames(styles.wrapPhonePrice, styles.nonFixed)
  }, renderPrice()));

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: () => /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: deco,
      className: styles.bgHero
    }),
    renderPhone: () => isShowDecoHero ? /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: deco,
      className: styles.bgHero
    }) : null,
    renderTablet: () => isShowDecoHero ? /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: deco,
      className: styles.bgHero
    }) : null
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.wrapContainer)
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: styles.backButton,
    label: "Go back",
    onClick: onClickGoBack
  }), /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.top
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.left
    }, renderHeroImg()), /*#__PURE__*/React.createElement("div", {
      className: styles.right
    }, renderHeroInfo(), renderPrice(), renderRentalReward(), renderOwner())), /*#__PURE__*/React.createElement(StatsSection, {
      key: "desktop",
      tabs: [StatsTab.P2E, StatsTab.Stats, StatsTab.Fury, StatsTab.Passive],
      className: styles.statsSection,
      renderedPanel: renderedPanel
    }))),
    renderPhone: renderMobileAndTablet,
    renderTablet: renderMobileAndTablet
  })), isShowButtonFixed && /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: renderPhonePrice,
    renderTablet: renderPhonePrice,
    renderDesktop: () => null
  })));
};

export default ItemDetail;